import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';

const Login = () => {
    const [instanceUrl, setInstanceUrl] = useState(localStorage.getItem('instanceUrl') || 'misskey.io');
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    
    const handleLogin = (e) => {
        e.preventDefault();
        
        let formattedUrl = instanceUrl.trim().replace(/\/$/, '');
        if (!formattedUrl.startsWith('http')) {
            formattedUrl = `https://${formattedUrl}`;
        }
        
        localStorage.setItem('instanceUrl', formattedUrl);

        const sessionId = uuidv4();
        const callbackUrl = `${window.location.origin}/callback`;
        const name = "Misskey FileView";
        const permission = 'read:account,read:admin:drive';

        // MiAuth URL
        const miauthUrl = `${formattedUrl}/miauth/${sessionId}?name=${encodeURIComponent(name)}&callback=${encodeURIComponent(callbackUrl)}&permission=${encodeURIComponent(permission)}`;
        
        localStorage.setItem('miauth_session', sessionId);
        
        setIsLoading(true);
        window.location.href = miauthUrl;
    };

    useEffect(() => {
        const token = localStorage.getItem('authToken');
        if (token) navigate('/files', { replace: true });
    }, [navigate]);

    return (
        <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
            <div className="sm:mx-auto sm:w-full sm:max-w-md">
                <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
                    Connect to Misskey (MiAuth)
                </h2>
                <p className="mt-2 text-center text-sm text-gray-600">
                    Enter your instance URL to get started
                </p>
            </div>

            <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
                <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
                    <form className="space-y-6" onSubmit={handleLogin}>
                        <div>
                            <label htmlFor="instanceUrl" className="block text-sm font-medium text-gray-700">
                                Instance URL
                            </label>
                            <div className="mt-1 relative rounded-md shadow-sm">
                                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                    <span className="text-gray-500 sm:text-sm">https://</span>
                                </div>
                                <input
                                    type="text"
                                    name="instanceUrl"
                                    id="instanceUrl"
                                    className="focus:ring-blue-500 focus:border-blue-500 block w-full pl-16 sm:text-sm border-gray-300 rounded-md py-2 border"
                                    placeholder="misskey.io"
                                    value={instanceUrl.replace(/^https?:\/\//, '')}
                                    onChange={(e) => setInstanceUrl(e.target.value)}
                                    required
                                />
                            </div>
                        </div>

                        <div>
                            <button
                                type="submit"
                                className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                                disabled={isLoading}
                            >
                                {isLoading ? 'Redirecting...' : 'Login with MiAuth'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Login;
